import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Link } from '../../routes';
import { ButtonTag } from '../../components/Button/styles';
import { IndexPageSection, HotelCard, Skeleton } from '../../components';
import { ArrowRight, axiosInstance, slugify } from '../../utils';

import {
  FeaturedList,
  FeaturedItem,
  FeaturedButtonContainer,
  FeaturedHeaderAdditionalContainer,
  FeaturedAll,
} from './styles';

const mapStateToProps = state => ({
  coords: state.user.location,
  userCity: state.userPreferences.city
});

@connect(mapStateToProps)
class FeaturedHotelPasses extends Component {
  static propTypes = {
    featured: PropTypes.instanceOf(Array),
    coords: PropTypes.instanceOf(Object),
    userCity: PropTypes.instanceOf(Object),
  };

  state = {
    featured: [],
  };

  componentDidMount() {
    this.fetchFeaturedHotels();
  }

  componentDidUpdate(prevProps) {
    const { coords } = prevProps;
    const { coords: newCoords } = this.props;

    if (coords.longitude !== newCoords.longitude) {
      this.fetchFeaturedHotels();
    }
  }

  fetchFeaturedHotels = async () => {
    this.setState({
      featured: [],
    });
    const { coords: newCoords } = this.props;
    const { latitude, longitude } = newCoords;

    let requestUrl;

    if (latitude && longitude) {
      requestUrl = `products/featured?page=1&limit=8&latitude=${latitude}&longitude=${longitude}`;
    } else {
      requestUrl = 'products/featured?page=1&limit=8';
    }

    const { data: featured } = await axiosInstance.get(requestUrl);
    await this.setState({
      featured: featured.products,
    });
  };

  render() {
    const { featured } = this.state;
    const { userCity } = this.props;
    const { label, market } = userCity;

    return (
      <IndexPageSection
        heading={(
          <Fragment>
            <span>Featured</span> hotel passes
          </Fragment>
        )}
        headerAdditional={(
          <FeaturedHeaderAdditionalContainer>
            <Link href={`/s/${slugify(market)}/day-pass?product=Day%20Pass&market=${label}&date=${moment().format('YYYY-MM-DD')}&guests=2&priceHi=300&priceLo=0&distanceHi=0&distanceLo=0&sortType=2&experience=Festive%2CFamily%2CTranquil`}>
              <a>
                <FeaturedAll>
                  All featured
                  <ArrowRight width={16} height={12} />
                </FeaturedAll>
              </a>
            </Link>
          </FeaturedHeaderAdditionalContainer>
        )}
        hasRelativePosition
      >
        <FeaturedList>
          {featured.length === 0 ? (
            <Fragment>
              {Array(8)
                .fill(0)
                .map((hotel, index) => (
                  <FeaturedItem key={index} style={{ fontSize: 0 }}>
                    <Skeleton height={180} marginBottom={15} />
                    <Skeleton height={20} marginBottom={5} />
                    <Skeleton height={20} marginBottom={10} />
                    <Skeleton height={20} />
                  </FeaturedItem>
                ))}
            </Fragment>
          ) : (
            <Fragment>
              {featured.map(hotel => (
                <FeaturedItem key={hotel.id}>
                  <Link
                    route="product"
                    prefetch
                    params={{
                      marketName: slugify(hotel.marketName),
                      hotelName: slugify(hotel.hotelName),
                      hid: hotel.hotelId,
                      pid: hotel.id,
                    }}
                  >
                    <a>
                      <HotelCard image={hotel.image} {...hotel} />
                    </a>
                  </Link>
                </FeaturedItem>
              ))}
            </Fragment>
          )}
        </FeaturedList>
        <FeaturedButtonContainer>
          <Link href={`/s/${slugify(market)}/day-pass?product=Day%20Pass&market=${label}&date=${moment().format('YYYY-MM-DD')}&guests=2&priceHi=300&priceLo=0&distanceHi=0&distanceLo=0&sortType=2&experience=Festive%2CFamily%2CTranquil`}>
            <a>
              <ButtonTag as="span" btnType="secondary">
                All featured
                <ArrowRight width={16} height={12} />
              </ButtonTag>
            </a>
          </Link>
        </FeaturedButtonContainer>
      </IndexPageSection>
    );
  }
}

export default FeaturedHotelPasses;
